import { Pricing } from 'modules/onboarding/lib/pricing/types'
import Plan from './Plan'
import type PlanVariant from './PlanVariant'
import { initF25AddonVariants } from './f25Addon'
import { initF25PlanVariants } from './f25Plan'

export type F25PlanDTO = {
  f25Plans: Plan[]
  f25Addons: Plan[]
}

function getF25Plans(rawBundles: Pricing, country: string) {
  const f25AddonVariants = initF25AddonVariants(rawBundles, country)
  const f25PlanVariants = initF25PlanVariants(rawBundles, country)

  return {
    f25Plans: groupVariants(f25PlanVariants),
    f25Addons: groupVariants(f25AddonVariants),
  }
}

function groupVariants(variants: PlanVariant[]): Plan[] {
  const plans: Record<PlanVariant['title'], Plan> = {}

  variants.forEach((variant) => {
    const plan = plans[variant.title.toLowerCase()]
    if (!plan) {
      plans[variant.title.toLowerCase()] = new Plan(variant)
    } else {
      plan.addVariant(variant)
    }
  })
  return Object.values(plans)
}

export default getF25Plans
